import Container from "@components/Atomic/Container/Container";
import React from "react";
import tw from "twin.macro";
import FeaturedArticleCard from "./FeaturedArticleCard";

const OuterWrapper = tw.div`
  w-full py-mega max-w-2xl mx-auto px-mini sm:px-maxi md:p-tera
`;

const Wrapper = tw.div`
  flex flex-wrap md:-mx-mini
`;

export interface FeaturedArticleProps {
  styles: any;
  articles: any;
}

export function FeaturedArticle({ styles, articles }: FeaturedArticleProps) {
  return (
    <Container styles={styles}>
      <OuterWrapper>
        <Wrapper>
          {articles.map((article) => (
            <FeaturedArticleCard key={article._id} article={article} />
          ))}
        </Wrapper>
      </OuterWrapper>
    </Container>
  );
}
